import { useState, useEffect, useCallback } from 'react';

const ADMIN_SESSION_KEY = 'mg_admin_session';

interface AdminSession {
  username: string;
  expiresAt: number;
}

export function useAdminAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [username, setUsername] = useState('');

  useEffect(() => {
    const raw = localStorage.getItem(ADMIN_SESSION_KEY);
    if (raw) {
      try {
        const session: AdminSession = JSON.parse(raw);
        if (session.expiresAt > Date.now()) {
          setIsAuthenticated(true);
          setUsername(session.username);
        } else {
          localStorage.removeItem(ADMIN_SESSION_KEY);
        }
      } catch {
        localStorage.removeItem(ADMIN_SESSION_KEY);
      }
    }
    setIsLoading(false);
  }, []);

  const login = useCallback((user: string) => {
    const session: AdminSession = {
      username: user,
      expiresAt: Date.now() + 8 * 60 * 60 * 1000, // 8h
    };
    localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(session));
    setIsAuthenticated(true);
    setUsername(user);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(ADMIN_SESSION_KEY);
    setIsAuthenticated(false);
    setUsername('');
  }, []);

  return { isAuthenticated, isLoading, username, login, logout };
}
